import { render } from "./VideoPopupComponent.vue?vue&type=template&id=8777cece&scoped=true"
import script from "./VideoPopupComponent.vue?vue&type=script&lang=js"
export * from "./VideoPopupComponent.vue?vue&type=script&lang=js"

import "./VideoPopupComponent.vue?vue&type=style&index=0&id=8777cece&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8777cece"]])

export default __exports__